export enum ImportStatus {
    InProgress,
    Finished,
    CompletedWithErrors
}
